const diagnosticRoutes = [
    {
      path: "diagnostic",
      name: "Diagnostic",
      redirect: {
        name: "ListDiagnostic"
      },
      component: () =>
        import(
          /* webpackChunkName: "surveys" */ "../../views/diagnostic/Diagnostic.vue"
        ),
      children: [
        {
          path: "category",
          name: "DaignosticCategory",
          component: () =>
            import(
              /* webpackChunkName: "surveys" */ "../../views/diagnostic/DaignosticCategory.vue"
            )
        },
        {
          path: "edit/:id",
          name: "Edit Diagnostic",
          component: () =>
            import(
              /* webpackChunkName: "surveys" */ "../../views/diagnostic/NewDiagnostic.vue"
            )
        },
        {
            path: "list",
            name: "ListDiagnostic",
            component: () =>
              import(
                /* webpackChunkName: "surveys" */ "../../views/diagnostic/DiagnosticList.vue"
              )
          },
          {
          path: "detail/:id/:name",
            name: "Diagnostic Detail",
            component: () =>
              import(
                /* webpackChunkName: "surveys" */ "../../views/diagnostic/DiagnosticDetail.vue"
              )
          },
        {
          path: "templates",
          name: "ListTemplates",
          component: () =>
            import(
              /* webpackChunkName: "surveys" */ "../../views/diagnostic/TemplateList.vue"
            )
        },
        {
          path: "template/:id/:mode",
          name: "Edit Template",
          component: () =>
            import(
              /* webpackChunkName: "surveys" */ "../../views/diagnostic/NewTemplate.vue"
            )
        }
      ]
    }
  ];
  
  export default diagnosticRoutes;
  